const ProjectBasicInfo = ({
  formData,
  setFormData,
  organizations = [],
  employees = [],
}) => {

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="space-y-6">

      <div>
        <h3 className="text-xl font-bold text-slate-800">
          Basic Information
        </h3>

        <p className="mt-1 text-sm text-slate-500">
          Enter the basic details of the project.
        </p>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-6">

        <div className="grid grid-cols-2 gap-5">

          {/* ORGANIZATION */}

          <div className="col-span-2">
            <label className="text-sm font-medium text-slate-700">
              Organization *
            </label>

            <select
              name="organization_uuid"
              value={formData.organization_uuid || ""}
              onChange={handleChange}
              required
              className="mt-2 w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 outline-none focus:border-blue-500"
            >
              <option value="">
                Select organization
              </option>

              {organizations.map((organization) => (
                <option
                  key={organization.uuid}
                  value={organization.uuid}
                >
                  {organization.display_name}
                </option>
              ))}
            </select>
          </div>

          {/* PROJECT CODE */}

          <div>
            <label className="text-sm font-medium text-slate-700">
              Project Code *
            </label>

            <input
              type="text"
              name="project_code"
              value={formData.project_code || ""}
              onChange={handleChange}
              placeholder="PRJ-001"
              required
              className="mt-2 w-full rounded-lg border border-slate-300 px-4 py-2.5 outline-none focus:border-blue-500"
            />
          </div>

          {/* PROJECT NAME */}

          <div>
            <label className="text-sm font-medium text-slate-700">
              Project Name *
            </label>

            <input
              type="text"
              name="project_name"
              value={formData.project_name || ""}
              onChange={handleChange}
              placeholder="ERP Management System"
              required
              className="mt-2 w-full rounded-lg border border-slate-300 px-4 py-2.5 outline-none focus:border-blue-500"
            />
          </div>

          {/* PROJECT TYPE */}

          <div>
            <label className="text-sm font-medium text-slate-700">
              Project Type *
            </label>

            <select
              name="project_type"
              value={formData.project_type || ""}
              onChange={handleChange}
              required
              className="mt-2 w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 outline-none focus:border-blue-500"
            >
              <option value="">
                Select project type
              </option>

              <option value="Internal Product">
                Internal Product
              </option>

              <option value="Client Project">
                Client Project
              </option>

              <option value="Marketing Campaign">
                Marketing Campaign
              </option>

              <option value="Content Production">
                Content Production
              </option>

              <option value="Sales Campaign">
                Sales Campaign
              </option>

              <option value="Recruitment">
                Recruitment
              </option>

              <option value="Operations">
                Operations
              </option>

              <option value="Research">
                Research
              </option>

              <option value="Other">
                Other
              </option>
            </select>
          </div>

          {/* EXECUTION MODE */}

          <div>
            <label className="text-sm font-medium text-slate-700">
              Execution Mode *
            </label>

            <select
              name="execution_mode"
              value={formData.execution_mode || ""}
              onChange={handleChange}
              required
              className="mt-2 w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 outline-none focus:border-blue-500"
            >
              <option value="">
                Select execution mode
              </option>

              <option value="Work">
                Work
              </option>

              <option value="Pipeline">
                Pipeline
              </option>

              <option value="Hybrid">
                Hybrid
              </option>
            </select>
          </div>

          {/* PRIORITY */}

          <div>
            <label className="text-sm font-medium text-slate-700">
              Priority *
            </label>

            <select
              name="priority"
              value={formData.priority || "Medium"}
              onChange={handleChange}
              required
              className="mt-2 w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 outline-none focus:border-blue-500"
            >
              <option value="Low">
                Low
              </option>

              <option value="Medium">
                Medium
              </option>

              <option value="High">
                High
              </option>

              <option value="Critical">
                Critical
              </option>
            </select>
          </div>

          {/* =====================================================
              PROJECT MANAGER
          ===================================================== */}

          <div>
            <label className="text-sm font-medium text-slate-700">
              Project Manager *
            </label>

            <select
              name="project_manager_employee_uuid"
              value={
                formData.project_manager_employee_uuid || ""
              }
              onChange={handleChange}
              required
              className="mt-2 w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 outline-none focus:border-blue-500"
            >

              <option value="">
                Select project manager
              </option>

              {employees.map((employee) => {

                const employeeUuid =
                  employee.uuid ||
                  employee.employee_uuid ||
                  employee.id;

                const employeeName =
                  employee.name ||
                  employee.employee_name ||
                  employee.full_name ||
                  employee.employeeName ||
                  (
                    employee.first_name &&
                    employee.last_name
                      ? `${employee.first_name} ${employee.last_name}`
                      : ""
                  ) ||
                  (
                    employee.firstName &&
                    employee.lastName
                      ? `${employee.firstName} ${employee.lastName}`
                      : ""
                  ) ||
                  "Unnamed Employee";

                return (
                  <option
                    key={employeeUuid}
                    value={employeeUuid}
                  >
                    {employeeName}
                  </option>
                );
              })}

            </select>
          </div>

          {/* CLIENT NAME */}

          <div>
            <label className="text-sm font-medium text-slate-700">
              Client Name
            </label>

            <input
              type="text"
              name="client_name"
              value={formData.client_name || ""}
              onChange={handleChange}
              placeholder="ABC Technologies"
              className="mt-2 w-full rounded-lg border border-slate-300 px-4 py-2.5 outline-none focus:border-blue-500"
            />
          </div>

          {/* DESCRIPTION */}

          <div className="col-span-2">
            <label className="text-sm font-medium text-slate-700">
              Description
            </label>

            <textarea
              name="description"
              value={formData.description || ""}
              onChange={handleChange}
              rows={5}
              placeholder="Describe the project..."
              className="mt-2 w-full resize-none rounded-lg border border-slate-300 px-4 py-3 outline-none focus:border-blue-500"
            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default ProjectBasicInfo;